(() => {
  'use strict';
  if (customElements.get('misaki-black-gift-preview')) return;
  customElements.define('misaki-black-gift-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      const template = this.querySelector('template');
      if (!template) return;
      const root = this.attachShadow({ mode: 'open' });
      root.append(template.content.cloneNode(true));
      const media = JSON.parse(root.querySelector('[data-gift-assets]').textContent);

  const signup = this.querySelector('[data-black-gift-signup]');
  const physicalEnabled = this.dataset.redemptionEnabled === 'true';
  const physicalForms = {
    cloth: 'VxUQTH', oil: 'WF5Fz6', sheath_one: 'Vh6jHe',
    apron250: 'SeCkXv', sheath_two: 'YahMLb'
  };
  const signupStatus = signup?.querySelector('[data-signup-status]');
  let activeFormId = null;
  let activeForm = null;
  let signupTimer;
  function updateSignupStatus() {
    if (activeForm?.querySelector('form, input[type="email"]') && signupStatus) {
      window.MisakiBlackGiftCampaign?.prefill(activeForm);
      signupStatus.hidden = true;
      clearTimeout(signupTimer);
    }
  }
  const signupObserver = signup ? new MutationObserver(updateSignupStatus) : null;
  signupObserver?.observe(signup, { childList: true, subtree: true });

  function showSignup(visible) {
    if (!signup) return;
    if (visible) {
      activeFormId = selected === 'credit' ? 'UnyV9J' : (physicalEnabled && physicalForms[selected]) || 'TduXJ4';
      activeForm = signup.querySelector(`[data-signup-form="${activeFormId}"]`);
      signup.querySelectorAll('[data-signup-form]').forEach(form => { form.hidden = form !== activeForm; });
      if (signupStatus) {
        signupStatus.hidden = false;
        signupStatus.textContent = 'Anmeldeformular wird geladen …';
      }
    }
    signup.hidden = !visible;
    $('signup-panel').hidden = !visible;
    $('confirm-button').hidden = true;
    clearTimeout(signupTimer);
    updateSignupStatus();
    if (visible && signupStatus && !signupStatus.hidden) {
      signupTimer = setTimeout(() => {
        signupStatus.textContent = 'Das Anmeldeformular ist derzeit nicht verfügbar. Bitte laden Sie die Seite erneut oder versuchen Sie es später nochmals.';
      }, 8000);
    }
  }

  const storageKey = 'misaki:black-gift:shopify-preview:v1';
  const lifetime = 7 * 24 * 60 * 60 * 1000;
  const gifts = {
    care: { category: 'PFLEGE', value: 'Regulärer Einzelwert CHF 39.90', name: 'Care Kit', description: 'Kamelienöl und Mikrofasertuch. Für die Pflege Ihrer MISAKI Messer.', contents: 'Ein Kamelienöl und ein Mikrofasertuch als Geschenkpaket.' },
    apron: { category: 'KÜCHE', value: 'Wert CHF 45', name: 'Küchenschürze', description: 'Schwarze MISAKI Schürze für die Küche.', contents: 'Eine schwarze MISAKI Küchenschürze.' },
    cloth: { category: 'PFLEGE', threshold: 100, value: 'Wert CHF 9.45', name: 'Mikrofasertuch', description: 'Für die schonende Pflege Ihrer MISAKI Messer.' },
    credit: { category: 'GRAVUR', threshold: 100, value: 'Wert CHF 25', name: 'CHF 25 Gravur-Bonus', description: 'Für Ihr Messer mit persönlicher Gravur.' },
    oil: { category: 'PFLEGE', threshold: 200, value: 'Wert CHF 24.95', name: 'Kamelienöl', description: 'Pflege für die Klingen Ihrer MISAKI Messer.' },
    sheath_one: { category: 'SCHUTZ', threshold: 200, value: 'Wert CHF 29.95', name: 'Eine Walnussholz-Scheide', description: 'Eine passende Scheide zu Ihrem Einzelmesser oder 2er-Set. Brotmesser ausgenommen.' },
    apron250: { category: 'KÜCHE', threshold: 250, value: 'Wert CHF 45', name: 'Küchenschürze', description: 'Schwarze MISAKI Schürze für die Küche.' },
    sheath_two: { category: 'SCHUTZ', threshold: 300, value: 'Wert CHF 53.90', name: 'Zwei Walnussholz-Scheiden', description: 'Zwei passende Scheiden zu Ihrem 2er-Messerset.' }
  };

  const $ = id => root.getElementById(id);
  const cards = [...root.querySelectorAll('[data-gift]')];
  let currentCart = window.MisakiBlackGiftCart?.snapshot() || null;
  const stage = $('reveal-stage');
  const surface = $('cut-surface');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let selected = null;
  let phase = 'choose';
  let pointer = null;
  let revealTimer = null;
  let sliceFrame = null;
  let progressValue = 0;
  let threshold = 100;
  let remembered = null;
  let submission = null;
  let creditCartReady = false;
  let submissionGift = null;
  let selectionTimer;
  let submissionTimer;
  let submitting = false;
  let selectionRequest = 0;
  let disposed = false;

  function selectionMessage(message, retry = false) {
    $('selection-feedback').hidden = false;
    $('selection-message').textContent = message;
    $('selection-retry').hidden = !retry;
  }

  function captureSubmission(event) {
    if (phase !== 'reveal' || submission || submitting) return;
    if (physicalEnabled && !window.MisakiBlackGiftRules?.selectionEligibility(currentCart, selected).eligible) {
      event.preventDefault(); event.stopImmediatePropagation(); refreshAvailability(); return;
    }
    const isAction = event.type === 'submit' ||
      (event.type === 'click' && event.target.closest('button')) ||
      (event.type === 'keydown' && event.key === 'Enter');
    const input = activeForm?.querySelector('input[type="email"]');
    if (isAction && input?.value && input.checkValidity()) {
      submissionGift = selected;
      submitting = true;
      $('back-button').disabled = true;
      submissionTimer = setTimeout(() => {
        if (submission || disposed) return;
        selectionMessage('Ihre Anmeldung wurde noch nicht bestätigt. Bitte prüfen Sie das Formular. Falls es nicht reagiert, laden Sie die Seite erneut.');
      }, 20000);
    }
  }

  async function sendSelection() {
    if (!submission || disposed) return;
    const request = ++selectionRequest;
    const gift = submission.gift;
    selectionMessage('Ihre Geschenkauswahl wird übermittelt …');
    $('back-button').disabled = true;
    let timedOut = false;
    clearTimeout(selectionTimer);
    selectionTimer = setTimeout(() => {
      timedOut = true;
      selectionMessage('Ihre Anmeldung wurde übermittelt. Die Geschenkauswahl konnte noch nicht bestätigt werden. Bitte versuchen Sie die Übertragung erneut.', true);
    }, 10000);
    try {
      const properties = {
        email: submission.email,
        'Black Gift Campaign': '2026-11',
        'Black Gift Choice': gift,
        'Black Gift Name': gifts[gift].name
      };
      const operation = typeof window.klaviyo?.identify === 'function'
        ? window.klaviyo.identify(properties)
        : new Promise(resolve => {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['identify', properties, resolve]);
        });
      if (!operation || typeof operation.then !== 'function') throw new Error('No acknowledgement');
      const result = await operation;
      if (disposed || request !== selectionRequest || timedOut) return;
      if (result === false) throw new Error('Not acknowledged');
      clearTimeout(selectionTimer);
      selectionMessage(`Ihre Wahl: ${gifts[gift].name}. Die Auswahl wurde übermittelt. Ein Rabatt wurde noch nicht aktiviert.`);
      submission.email = null;
    } catch {
      if (disposed || request !== selectionRequest) return;
      clearTimeout(selectionTimer);
      selectionMessage('Ihre Anmeldung wurde übermittelt. Die Geschenkauswahl konnte noch nicht bestätigt werden. Bitte versuchen Sie die Übertragung erneut.', true);
    }
  }

  function onSignup(event) {
    const detail = event.detail;
    if (!signup || submission || (!submissionGift && phase !== 'reveal') ||
        detail?.formId !== activeFormId || detail.type !== 'submit') return;
    const email = detail.metaData?.email || detail.metaData?.$email;
    const gift = submissionGift || selected;
    if (!Object.hasOwn(gifts, gift)) return;
    if (physicalEnabled && physicalForms[gift]) {
      clearTimeout(submissionTimer);
      submitting = false;
      submission = { gift, email: null };
      $('back-button').disabled = true;
      $('gift-redemption').hidden = false;
      updateGiftCode();
      return;
    }
    if (gift === 'credit') {
      clearTimeout(submissionTimer);
      submitting = false;
      try { window.MisakiBlackGiftCart?.forget(); }
      catch (error) { selectionMessage(error.message); return; }
      submission = { gift, email: null };
      $('back-button').disabled = true;
      selectionMessage('Die Gravur wählen und gestalten Sie auf der Produktseite selbst.');
      updateGiftCode();
      return;
    }
    if (typeof email !== 'string' || !email.includes('@')) {
      selectionMessage('Die Geschenkauswahl konnte Ihrer Anmeldung nicht zugeordnet werden. Bitte laden Sie die Seite neu und versuchen Sie es nochmals.');
      return;
    }
    clearTimeout(submissionTimer);
    submitting = false;
    if (gift !== selected || phase !== 'reveal') {
      selectGift(gift);
      openWrapping();
    }
    submission = { email, gift };
    sendSelection();
  }

  function updateGiftCode() {
    if (submission?.gift === 'credit') {
      const code = [...(activeForm?.querySelectorAll('button, [role="button"]') || [])]
        .map(button => button.textContent.trim().toUpperCase())
        .find(value => /^BG26-GRAVUR-[A-Z0-9]+$/.test(value));
      if (!code || !creditCartReady) return;
      const link = $('gift-cart-link');
      const cartPath = link.getAttribute('href').split('?redirect=')[1] || link.getAttribute('href');
      link.href = `/discount/${encodeURIComponent(code)}?redirect=${cartPath}`;
      link.textContent = 'Bonus im Warenkorb aktivieren →';
      $('gift-code').hidden = true;
      root.querySelector('label[for="gift-code"]').hidden = true;
      $('gift-redemption').hidden = false;
      $('back-button').disabled = false;
      return;
    }
    if (!physicalEnabled || !submission || !physicalForms[submission.gift]) return;
    const prefix = window.MisakiBlackGiftRules?.gifts[submission.gift]?.prefix;
    if (!prefix) return;
    const coupon = [...(activeForm?.querySelectorAll('button, [role="button"]') || [])]
      .map(button => button.textContent.trim().toUpperCase())
      .find(code => window.MisakiBlackGiftRules.validCode(submission.gift, code));
    if (coupon) $('gift-code').value = coupon;
    const code = $('gift-code').value.trim().toUpperCase();
    if (!window.MisakiBlackGiftRules?.validCode(submission.gift, code)) return;
    try {
      window.MisakiBlackGiftCart.remember(submission.gift, code);
      $('gift-code').hidden = true;
      $('back-button').disabled = false;
      root.querySelector('label[for="gift-code"]').hidden = true;
      $('gift-redemption-status').textContent = `Ihr Geschenk ist vorgemerkt und wird ab CHF ${gifts[submission.gift].threshold} automatisch hinzugefügt.`;
    } catch (error) {
      $('gift-redemption-status').textContent = error.message === 'Es ist bereits ein Geschenk vorgemerkt.' ? error.message : 'Die Vormerkung konnte nicht gespeichert werden. Bitte prüfen Sie Ihre Browser-Einstellungen.';
    }
  }
  const couponObserver = signup ? new MutationObserver(updateGiftCode) : null;
  couponObserver?.observe(signup, { childList: true, subtree: true, characterData: true });
  $('gift-code').addEventListener('change', updateGiftCode);

  signup?.addEventListener('submit', captureSubmission, true);
  signup?.addEventListener('click', captureSubmission, true);
  signup?.addEventListener('keydown', captureSubmission, true);
  window.addEventListener('klaviyoForms', onSignup);
  $('selection-retry')?.addEventListener('click', sendSelection);

  function currentGift() { return gifts[selected]; }

  function showBenefits() {
    $('gift-benefits').hidden = false;
    $('gift-value').hidden = false;
    $('gift-value').textContent = currentGift().value || '';
  }

  function condition() {
    return selected === 'credit' ? 'Zu Ihrem Messer mit Gravur. Einkauf ab CHF 100.'
      : selected === 'sheath_one' ? 'Zu einem passenden HIKARI- oder AKANE-Messer ab CHF 200.'
        : selected === 'sheath_two' ? 'Zu einem passenden 2er-Messerset ab CHF 300.' : `Zu Ihrem Einkauf ab ${amount()}.`;
  }
  function amount() { return `CHF ${new Intl.NumberFormat('de-CH').format(currentGift()?.threshold || threshold)}`; }

  function setProgress(value) {
    const progress = Math.max(0, Math.min(1, value));
    progressValue = progress;
    $('cut-fill').style.width = `${progress * 100}%`;
    $('cut-handle').style.left = `${progress * 100}%`;

    stage.style.setProperty('--light-x', `${22 + progress * 60}%`);
  }

  function resetSlider() {
    $('opening-range').value = 0;
    $('opening-range').disabled = false;
    updateSlider();
  }

  function updateSlider() {
    const value = Number($('opening-range').value);
    $('opening-range').style.setProperty('--fill', `${value}%`);
    $('opening-percent').textContent = `${value} %`;
  }

  function stopCut() {
    if (pointer && surface.hasPointerCapture(pointer.id)) surface.releasePointerCapture(pointer.id);
    pointer = null;
    stage.classList.remove('is-cutting');
    if (phase === 'cut' || phase === 'choose') { setProgress(0); bladePose(-6, 0, 0); }
    if (phase === 'cut' || phase === 'choose') resetSlider();
  }

  function steps(step) {
    root.querySelectorAll('[data-step]').forEach(item => {
      if (item.dataset.step === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }

  function focusPanel(element, scroll = true) {
    if (scroll) $('experience').scrollIntoView({ behavior: 'instant', block: 'start' });
    element.focus({ preventScroll: true });
  }

  function image(src, alt) {
    const img = document.createElement('img');
    img.src = media[src];
    img.alt = alt;
    img.width = 800;
    img.height = 800;
    img.draggable = false;
    return img;
  }

  function productDisplay() {
    const display = $('product-display');
    display.replaceChildren();
    if (selected === 'care') {
      display.append(image('care-kit-v3.png', 'MISAKI Care Kit mit Kamelienöl und Mikrofasertuch'));
    } else if (selected === 'credit') {
      const card = document.createElement('div');
      card.className = 'credit-art';
      const brand = document.createElement('span');
      brand.textContent = 'MISAKI / BLACK GIFT';
      const value = document.createElement('strong');
      value.textContent = 'CHF 25';
      const label = document.createElement('small');
      label.textContent = 'FÜR IHRE PERSÖNLICHE GRAVUR';
      card.append(brand, value, label);
      display.append(card);
    } else {
      const source = selected === 'cloth' ? 'cloth.jpg' : selected === 'oil' ? 'oil.jpg' : ['apron', 'apron250'].includes(selected) ? 'apron.jpg' : 'sheath.jpg';
      const alt = selected === 'cloth' ? 'MISAKI Mikrofasertuch' : selected === 'oil' ? 'MISAKI Kamelienöl' : ['apron', 'apron250'].includes(selected) ? 'Schwarze MISAKI Küchenschürze' : 'Walnussholz-Scheide an einem MISAKI Messer, Beispielabbildung';
      display.append(image(source, alt));
    }
  }

  function showChoice(focus = true) {
    if (submission || submitting) return;
    clearTimeout(revealTimer);
    cancelAnimationFrame(sliceFrame);
    stopCut();
    phase = 'choose';
    showSignup(false);
    $('choose-panel').hidden = false;
    $('detail-panel').hidden = true;
    steps('choose');
    if (focus) focusPanel(cards.find(card => card.dataset.gift === selected && !card.disabled) || $('choose-title'));
  }

  function selectGift(id) {
    if (physicalEnabled && !window.MisakiBlackGiftRules?.selectionEligibility(currentCart, id).eligible) return;
    if (submission || submitting || !gifts[id]) return;
    clearTimeout(revealTimer);
    cancelAnimationFrame(sliceFrame);
    stopCut();
    selected = id;
    showSignup(false);
    phase = 'cut';
    $('choose-panel').hidden = true;
    $('detail-panel').hidden = false;
    $('cut-actions').hidden = false;
    $('reveal-actions').hidden = true;
    $('confirmed-actions').hidden = true;
    $('back-button').hidden = false;
    $('open-button').disabled = false;
    stage.classList.remove('is-open', 'is-cutting', 'is-slicing');
    setProgress(0);
    bladePose(-6, 0, 0);
    resetSlider();
    $('product-display').setAttribute('aria-hidden', 'true');
    $('detail-eyebrow').hidden = true;
    $('detail-title').textContent = gifts[selected].category;
    $('detail-description').textContent = '';
    $('gift-benefits').hidden = true;
    productDisplay();
    if (!motion.matches) $('gift-object').animate([
      { opacity: 0, transform: 'translateY(24px) rotateX(14deg) rotateY(-16deg) rotateZ(-5deg) scale(.94)' },
      { opacity: 1, transform: 'rotateX(9deg) rotateY(-10deg) rotateZ(-3deg) scale(1)' }
    ], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
    steps('cut');
    focusPanel($('detail-title'));
  }

  function bladePose(angle, lift, depth) {
    stage.style.setProperty('--blade-angle', `${angle}deg`);
    stage.style.setProperty('--blade-lift', `${lift}px`);
    stage.style.setProperty('--blade-depth', `${depth}%`);
  }

  function reveal() {
    if (phase !== 'cut') return;
    phase = 'slicing';
    stopCut();
    setProgress(0);
    $('open-button').disabled = true;
    $('opening-range').value = 100;
    $('opening-range').disabled = true;
    updateSlider();
    if (motion.matches) { openWrapping(); return; }
    stage.style.setProperty('--blade-opacity', '0');
    stage.classList.add('is-slicing');
    let start;
    const ease = t => t * t * (3 - 2 * t);
    const slice = timestamp => {
      if (phase !== 'slicing') return;
      if (start === undefined) start = timestamp;
      const elapsed = timestamp - start;
      stage.style.setProperty('--blade-opacity', String(Math.min(1, elapsed / 280, Math.max(0, (1700 - elapsed) / 200))));
      if (elapsed < 480) {
        // Turn the handle upwards and lift the tip clear of the wrapping.
        const t = ease(elapsed / 480);
        bladePose(-6 - 59 * t, -38 * t, 0);
      } else if (elapsed < 720) {
        // Lower the tip into the seam; conceal its end beneath the paper.
        const t = Math.pow((elapsed - 480) / 240, 2);
        bladePose(-65, -38 + 43 * t, 8 * t);
      } else if (elapsed < 840) {
        bladePose(-65, 5, 8);
      } else if (elapsed < 1500) {
        const t = ease((elapsed - 840) / 660);
        setProgress(t);
        bladePose(-65 + 35 * t, 5, 8);
      } else if (elapsed < 1700) {
        const t = ease((elapsed - 1500) / 200);
        bladePose(-30 - 15 * t, 5 - 35 * t, 8 * (1 - t));
      } else {
        openWrapping();
        return;
      }
      sliceFrame = requestAnimationFrame(slice);
    };
    sliceFrame = requestAnimationFrame(slice);
    // A background tab can suspend frames; do not leave the action locked.
    revealTimer = setTimeout(() => {
      if (phase === 'slicing') openWrapping();
    }, 2200);
  }

  function openWrapping() {
    clearTimeout(revealTimer);
    cancelAnimationFrame(sliceFrame);
    phase = 'opening';
    setProgress(1);
    stage.classList.add('is-open');
    stage.classList.remove('is-slicing');
    revealTimer = setTimeout(() => {
      phase = 'reveal';
      $('product-display').removeAttribute('aria-hidden');
      $('cut-actions').hidden = true;
      $('reveal-actions').hidden = false;
      refreshAvailability();
      showSignup(!physicalEnabled || Boolean(window.MisakiBlackGiftRules?.selectionEligibility(currentCart, selected).eligible));
      $('detail-eyebrow').hidden = true;
      $('detail-eyebrow').textContent = '';
      $('detail-title').textContent = currentGift().name;
      $('detail-description').textContent = currentGift().description;
      showBenefits();
      $('gift-condition').hidden = false;
      $('gift-condition').textContent = condition();
      refreshAvailability();
      $('status').textContent = `${currentGift().name} geöffnet. Sie können Ihre Wahl jetzt bestätigen.`;
      steps('confirm');
      if (!motion.matches) root.querySelector('.detail-copy').animate([
        { opacity: .4, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 300, easing: 'ease-out' });
      focusPanel($('detail-title'), false);
    }, motion.matches ? 0 : 780);
  }

  function confirmed(saved, focus = true) {
    phase = 'confirmed';
    stage.classList.add('is-open');
    $('product-display').removeAttribute('aria-hidden');
    $('cut-actions').hidden = true;
    $('reveal-actions').hidden = true;
    $('confirmed-actions').hidden = false;
    $('back-button').hidden = true;
    $('detail-eyebrow').hidden = true;
    $('detail-eyebrow').textContent = '';
    $('detail-title').textContent = 'Geschenk ausgewählt.';
    $('detail-description').textContent = '';
    $('confirmed-name').textContent = currentGift().name;
    showBenefits();
    $('persistence-message').textContent = saved ? 'In dieser Vorschau gespeichert.' : 'Für diese Ansicht vorgemerkt. Ihr Browser erlaubt keine dauerhafte Speicherung.';
    steps('confirm');
    if (focus) focusPanel($('detail-title'), false);
  }

  function saveChoice() {
    if (phase !== 'reveal') return;
    remembered = { version: 2, gift: selected, threshold, savedAt: Date.now() };
    let saved = false;
    try { localStorage.setItem(storageKey, JSON.stringify(remembered)); saved = true; } catch {}
    confirmed(saved);
    $('status').textContent = 'Ihre Geschenk-Auswahl wurde in der Vorschau bestätigt. Es wurde kein Rabatt aktiviert.';
  }

  function updateSettings() {
    root.querySelectorAll('[data-threshold]').forEach(el => { el.textContent = amount(); });
  }

  function refreshAvailability() {
    if (!physicalEnabled) return;
    cards.forEach(card => {
      const result = window.MisakiBlackGiftRules?.selectionEligibility(currentCart, card.dataset.gift);
      card.disabled = !result?.eligible;
      card.querySelector('[data-card-status]').textContent = result?.eligible ? 'Freigeschaltet' : result?.reason || 'Ihr Warenkorb wird geprüft …';
    });
    const result = selected && window.MisakiBlackGiftRules?.selectionEligibility(currentCart, selected);
    const valid = !selected || result?.eligible;
    if (!submission && !submitting && phase === 'reveal') {
      showSignup(valid);
      $('gift-condition').textContent = valid ? condition() : result?.reason || 'Ihr Warenkorb wird geprüft …';
    }
    if (!submission && !submitting && phase === 'cut') {
      $('opening-range').disabled = !valid;
      $('open-button').disabled = !valid;
    }
    $('cart-qualification').textContent = !currentCart ? 'Ihr Warenkorb wird geprüft …'
      : currentCart.currency !== 'CHF' ? 'Black Gifts sind bei Einkäufen in CHF verfügbar.'
        : `Ihr Einkaufswert: CHF ${(window.MisakiBlackGiftRules.purchaseAmount(currentCart) / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. Ein Geschenk pro Bestellung.`;
  }
  function onCart(event) {
    currentCart = event.detail.cart;
    refreshAvailability();
    if (submission?.gift === 'credit') {
      creditCartReady = Boolean(currentCart && !event.detail.choice && !event.detail.message &&
        !currentCart.items.some(item => item.properties?._black_gift_attempt));
      updateGiftCode();
    } else if (submission && event.detail.choice?.gift === submission.gift && event.detail.message) {
      $('gift-redemption-status').textContent = event.detail.message;
    }
  }
  document.addEventListener('black-gift:cart', onCart);
  refreshAvailability();
  window.MisakiBlackGiftCart?.refresh();

  cards.forEach(card => {
    card.addEventListener('click', () => selectGift(card.dataset.gift));
  });
  $('back-button').addEventListener('click', () => submission ? window.location.reload() : showChoice());
  $('change-button').addEventListener('click', () => showChoice());
  $('open-button').addEventListener('click', reveal);
  $('confirm-button').addEventListener('click', saveChoice);
  $('shop-button').addEventListener('click', () => $('shop-dialog').showModal());
  $('opening-range').addEventListener('input', () => {
    if (phase !== 'cut') return;
    updateSlider();
    if (Number($('opening-range').value) === 100) reveal();
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !$('shop-dialog').open && ['cut', 'reveal'].includes(phase)) showChoice();
  });

  try {
    const saved = JSON.parse(localStorage.getItem(storageKey));
    if (saved?.version === 2 && Object.hasOwn(gifts, saved.gift) && Number.isFinite(saved.threshold) && saved.threshold >= 1 && saved.threshold <= 9999 && Number.isFinite(saved.savedAt) && Date.now() - saved.savedAt >= 0 && Date.now() - saved.savedAt < lifetime) remembered = saved;
    else localStorage.removeItem(storageKey);
  } catch {}
  if (remembered && !signup) {
    threshold = remembered.threshold;
    updateSettings();
    selected = remembered.gift;
    $('choose-panel').hidden = true;
    $('detail-panel').hidden = false;
    productDisplay();
    confirmed(true, false);
  } else updateSettings();

      this.dispose = () => {
        disposed = true;
        ++selectionRequest;
        clearTimeout(selectionTimer);
        clearTimeout(submissionTimer);
        submission = null;
        window.removeEventListener('klaviyoForms', onSignup);
        document.removeEventListener('black-gift:cart', onCart);
        signup?.removeEventListener('submit', captureSubmission, true);
        signup?.removeEventListener('click', captureSubmission, true);
        signup?.removeEventListener('keydown', captureSubmission, true);
        clearTimeout(signupTimer);
        signupObserver?.disconnect();
        couponObserver?.disconnect();
        clearTimeout(revealTimer);
        cancelAnimationFrame(sliceFrame);
      };
    }
    disconnectedCallback() { this.dispose?.(); }
  });
})();
